import React from 'react';
import { Close } from '@mui/icons-material';
import { IconButton, SvgIconProps, SxProps } from '@mui/material';

type CloseButtonProps = {
  onClick: () => void;
  size?: SvgIconProps['fontSize'];
  /** When true, the button does not close the dialog. */
  disabled?: boolean;
};

const CloseButton: React.FC<CloseButtonProps> = ({
  onClick,
  size = 'small',
  disabled = false,
}) => {
  return (
    <IconButton onClick={onClick} disabled={disabled} sx={closeButtonStyles}>
      <Close fontSize={size} />
    </IconButton>
  );
};

const closeButtonStyles: SxProps = { margin: 2 } as const;

export default CloseButton;
